module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAf0lEQVQ4T2NkIAD+//+/D6SEkZHRCZ9SRiIMegE1SGJ4GsTJwMBQisdrt4gNI3ECYfmeWINYGRgY/PAY9pRYg0DRP0xjjbDX/v//r8DAwCCNJyA3MTAw/CYYRv///3/HwMAgSCB6XxJjkAMDA4MaHoO6GRgYvhM0aGRnWqIKNgDRnk5YQT00pAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/static/images/product/huxing_tab.png
// module id = +atb
// module chunks = 1